import { Component, Fragment } from "react";
import {
  COMPANY_DATE_FORMATS,
  DECIMAL_PLACES,
  FORMAT,
  INPUT_TYPE,
  PAN_NUMBER_MASK,
  PROFILE_STAGES_CONSTANT,
  TAN_NUMBER_MASK,
  TDS_CIRCLE_MASK,
  DEFAULT_WORK_WEEK,
  ACCOUNT_TYPE,
  WORKWEEK_SEQUENCE,
  PAYRUN_CALC_CRITERIAS,
  ORGANIZATION_IDS,
  CONSTANTS,
  LOCATION,
  AUTO_CLOCK_TIME_DURATION,
  TIMESHEET_FREQUENCY
} from "../../constants/Constant";
import { PAN_REGEX_PATTERN, TAN_REGEX_PATTERN, TDS_REGEX_PATTERN } from "../../constants/RegexConstants";
import {
    DKLabel,
    DKRadioButton,
    DKLine,
    Toggle,
    DKIcon,
    DKInput,
    DKCheckMark,
    DKButton,
    INPUT_VIEW_DIRECTION,
    showToast,
    TOAST_TYPE,
    showLoader,
    removeLoader,
    DKTooltipWrapper,
    showAlert,
    DKIcons
} from "deskera-ui-library";
import DKInputDateTime from "../common/DKInputDateTime";
import ic_info_warning from "../../assets/icons/ic_info_gray.svg";
import Cheque from "../../assets/images/Cheque.svg"
import ReactTooltip from "react-tooltip";
import Address, { ADDRESS_MODULE, getAddressFields } from "../common/Address";
import RouteManager from "../../managers/RouteManager";
import CompanyDetailService from "../../services/CompanyDetailService";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import TenantManager from "../../managers/TenantManager";
import { COUNTRY, Countries } from "../../constants/CountryConstant";
import ProfileSetupService from "../../services/ProfileSetup-service";
import Utility from "../../utility/Utility";
import * as moment from "moment";
import FormatCurrencyService from "../../services/FormatCurrencyService";
import { isViewportLarge } from "../../utility/ViewportSizeUtils";
import { convertDateToJson, getTenantCountryCode, isCompanyDetailsSectionWiseSave, isUSCompliance, reverseTimezoneOffset } from "../../managers/common/CommonUtil";
import i18n, { getDefaultLangTitle, LANG } from "../../i18n/i18n";
import { LanguageMenuList } from "../menu/LabelList/LanguageMenuList";
import i18next from "../../i18n/i18n";
import { LeftMenuUpdate } from "../menu/LeftMenuService";
import MaskInput from "../../SharedComponents/MaskInput/MaskInput";
import addIcon from "../../assets/icons/ic_add.png";
import { connect } from "react-redux";
import { fetchCPFAccount } from "../../Redux/Slices/EmployeeListSlice"
import EmployeeListService from "../../services/EmployeeListService";
import AddCpfAccount from "../AddCpfAccount";
import AddEpfAccount from "../AddEpfAccount";
import ApiConstants from "../../constants/ApiConstants";
import CheckhqService from "../../services/CheckhqService";
import MessageInfo from "../common/MessageInfo";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

const SECTION = {
    ALL: "All",
    COMPANY_DETAILS: "Company Details",
    CONTACT_DETAILS: "Contact Details",
    CHECK_INTEGRATION: "Check Integration",
    CHECK_PRINTING: "Check Printing",
    DATE_FORMAT: "Date Format",
    DECIMAL_PLACES: "Decimal Places",
    PAYRUN_SETTINGS: "Payrun Settings",
    WORK_WEEK: "Work Week",
    CPF_ACCOUNT: "CPF Account",
    EPF_ACCOUNT: "EPF Account",
    AUTO_CLOCk_OUT_SETTINGS: "Auto clock-out configuration",
    WORKPLACE: "Workplace",
    SIGNATORY_INFORMATION: "Signatory Information",
    TERMS_OF_SERVICE: "Terms of Service",
    ATTENDANCE_ATTACHMENT: "Attendance Attachment",
    CUSTOM_FIELD_SECTION_ENABLED: "PW Custom field",
    SAVE_PROGRESS_EMP_PROFILE: "Save Progress of Employee Profile",
    TIMESHEET_SETTINGS: "Timesheet Configuration"
}

class CompanyDetails extends Component {
     workweek =  DEFAULT_WORK_WEEK;
     bankFields = ['bank','checkNumber','routingNumber','accountNumber'];
     isBankObjectId;
     countryList = Countries.map(c => {
        return {
            label: c.label,
            value: c.value
        }
    });
    constructor(props) {
        super(props);

        const countryCode = TenantService.get(TENANT.COUNTRY_CODE);

        this.state = {
          count: 0,
          countryCode: countryCode,
          companyData: null,
          companyFields: this.getCompanyFields(countryCode),
          isAddBankAcc: false,
          companyEmailId: null,
          payrunCalcCriteria: PAYRUN_CALC_CRITERIAS.NO_OF_DAYS_WORKED, 
          complianceFields: this.getComplianceFields(countryCode),
          extraFields: this.getExtraFields(countryCode),
          checkIntegrationFields: this.getCheckIntegrationFields(),
          addressFields: getAddressFields(
            countryCode,
            ADDRESS_MODULE.COMPANY_DETAILS
          ),
          dateFormat: {
            id: "dateFormat",
            title: "Select Date Format",
            type: INPUT_TYPE.DROPDOWN,
            value: this.getSelectLabel(
              TenantService.get(TENANT.DATE_FORMAT),
              COMPANY_DATE_FORMATS
            ),
            validation: [["required"]],
            options: COMPANY_DATE_FORMATS,
          },
          decimalFormat: {
            id: "decimalFormat",
            title: "Decimal Place",
            type: INPUT_TYPE.DROPDOWN,
            value: this.getSelectLabel(
              String(TenantService.get(TENANT.DECIMAL_FORMAT)),
              DECIMAL_PLACES
            ),
            validation: [["required"]],
            options: DECIMAL_PLACES,
          },
          language: {
            id: "language",
            title: "Select Language",
            type: "LANGUAGE_FIELD",
            value: getDefaultLangTitle(),
            validation: [["required"]],
            options: LanguageMenuList,
          },
          isDeskTop: isViewportLarge(),
          isLocationActive: true,
          locationType: {
            id: "locationType",
            title: "Location label",
            type: INPUT_TYPE.DROPDOWN,
            value: '',
            validation: [],
            options: this.getLocationOptions(),
          },
          checkNumber:{
            id: 'checkNumber',
            value:null,
            validation:{max:9},
            type:INPUT_TYPE.TEXT,
            isValid:false,
            canValidate:false
          },
          bank: {
              id: 'bank',
              value: '',
              type:INPUT_TYPE.TEXT,
              isValid: false,
              canValidate:false,
              validation: {
                  require: true
              }
          },
          accountNumber: {
              id: 'accountNumber',
              value: '',
              type: INPUT_TYPE.NUMBER,
              isValid: false,
              canValidate:false,
              validation: {
                  require: true,
                  min: 4,
                  max: 17
              }
          },
          routingNumber: {
              id: 'routingNumber',
              value: '',
              type: INPUT_TYPE.TEXT,
              isValid: false,
              canValidate:false,
              validation: {
                  require: true,
                  regex: `^(0[1-9]|1[0-2]|2[1-9]|3[0-2])([0-9]{7})$`

              }
            },
            cpfepfAccountDetails:{},
            cpfAccounts:[],
            cpfAccountConfig: {
                isAddCpfenabled : false,
                isEdit: false,
                accountDetails: {}
            },
            epfAccountDetails:{},
            epfAccounts:[],
            epfAccountConfig: {
                isAddEpfenabled : false,
                isEdit: false,
                epfAccountDetails: {}
            },
            isAutoClockOutEnabled : false,
            autoClockOut: {
                id: "autoClockOutDuration",
                title: "Auto clock-out user",
                type: INPUT_TYPE.DROPDOWN,
                value: this.getSelectLabel(String(0), AUTO_CLOCK_TIME_DURATION),
                validation: [["required"]],
                options: AUTO_CLOCK_TIME_DURATION,
                tooltip: "Selection of field suggests duration from shift/workday end time after which user will be clocked out automatically.<br><span class='fw-m'>For example:</span><br>1) If user's working hours ends at 5pm and auto clock-out duration is set as 1 hour then clock-out time will be 6pm in attendance record.<br>2) If working hours are 9am-5pm and user clocks-in at 12pm with auto clock-out happing at 6pm then user's attendance will be considered accordingly in payrun."
            },
            isAttendanceAttachmentsEnabled:false,
            customSectionFieldsEnabled:false,
            progressEmployeeProfileSaveButton:false,
            isContractor:false,            
            pwRegionField: {
                id: "pwRegion",
                title: "PW Region",
                type: INPUT_TYPE.DROPDOWN,
                value: this.getSelectLabel("", this.countryList),
                validation: null,
                options: this.countryList,
                tooltip: ""
            },
            timesheetPastDateRestrictionSet:false,
            timesheetRestrictionConfig: {
                id: 'timesheetRestriction',
                title: "No. of days to allow past date timesheet entry",
                value: '',
                type: INPUT_TYPE.NUMBER,
                isValid: false,
                validation: [["required"], ["integerOnly"], ["365days"]]
            },
            timesheetReminderEnabled: false,
            timesheetReminderConfig: {
                id: 'timesheetReminder',
                title: "No. of Days after which Reminder should be sent",
                value: '',
                type: INPUT_TYPE.NUMBER,
                isValid: false,
                validation: [["required"], ["integerOnly"], ["30days"]]
            },
            timesheetReminderCCAdmin: false,
            hasEditAccess: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT])
        };
    }

    addBankAccToggle() {
        const currentState = this.state.isAddBankAcc;
        this.setState({ isAddBankAcc: !currentState });
    }
    
    onChangeCheckNumber(obj) {
        let currentValue = Object.assign({},this.state.checkNumber);
        currentValue.value = obj.value;
        currentValue.isValid = obj.isValid;
        this.setState({ checkNumber: currentValue }); 
    }

    componentDidMount() {
        window.addEventListener("resize", this.windowSizeUpdated);
        if (Utility.isEmptyObject(this.props?.cpfepfAccountDetails)) this.getCpfEpfAccountDetails();
        RouteManager.setPresenter({ props: this.props });
        this.getCompanyDetails();
        if(isUSCompliance()) {
            if (TenantService.get(TENANT.IS_DIRECT_PAY_ENABLED)) {
                this.getBankDetails();
            }
            this.getCompanyAndIndustryType();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.windowSizeUpdated);
    }

    windowSizeUpdated = () => {
        this.setState({
            isDesktop: isViewportLarge(),
        });
    };

    getCpfEpfAccountDetails = () => {
        if(Utility.isEmptyObject(this.props?.cpfAccountDetails)) {
            const config = {
              Limit: 100,
              currentPage: 1,
              order: undefined,
              field: undefined,
              searchString: undefined,
            };
            EmployeeListService.apiConfig = config;
            this.props.fetchCPFAccount().then((response) => {
                const accounts = response?.payload?.accounts?.length > 0 ? response.payload.accounts : []
                this.setState({
                    cpfAccounts : accounts,
                    epfAccounts: accounts
                })
            })
        }
    }

    getCheckIntegrationFields() {
        const checkIntegrationFields = [
            {
                id: 'legalName',
                title: 'Company Legal Name',
                type: INPUT_TYPE.TEXT,
                validation: [["required"]],
                tooltip: "Legal name is the name registered with the state. This name will appear on your business’s tax returns."
            },
            {
                id: 'companyTradeName',
                title: 'Company Trade Name (DBA)',
                type: INPUT_TYPE.TEXT,
                validation: [["required"]],
                tooltip: "A trade name is also called a DBA (doing business as) name. Please mention that name if it is different from your legal name, otherwise fill in the legal name."
            },
            {
                id: 'companyStartDate',
                title: 'Start Date',
                type: INPUT_TYPE.DATE,
                validation: [["required"]],
                tooltip: "Company start date"
            },
            {
                id: 'industryType',
                title: 'Industry Type',
                type: INPUT_TYPE.DROPDOWN,
                validation: [["required"]],
                options: []
            }
        ];

        return checkIntegrationFields;
    }

    getCompanyAndIndustryType() {
        const checkCompanyTypes = TenantService.get(TENANT.CHECKHQ_COMPANY_TYPE);
        if (checkCompanyTypes) {
            this.setCompanyAndIndustryType(checkCompanyTypes);
        } else {
            CheckhqService.getCompanyAndIndustryType().then(
                (response) => {
                    if (response.checkCompanyTypes) {
                        TenantService.set(TENANT.CHECKHQ_COMPANY_TYPE, response.checkCompanyTypes);
                        this.setCompanyAndIndustryType(response.checkCompanyTypes);
                    }
                }, (error) => {
                    showToast("Error while fetching Industry type and Company type options", TOAST_TYPE.FAILURE);
                }
            );
        }
    }

    setCompanyAndIndustryType(checkCompanyTypes) {
        const tenantData = TenantManager.getPeopleTenantData();
        const checkIntegrationFields = [...this.state.checkIntegrationFields];
        checkIntegrationFields.forEach((field) => {
            if (field.id === "industryType") {
                field.options = checkCompanyTypes?.industryType || [];
                if (tenantData?.tenant?.compliance?.industryType) {
                    field.value = this.getSelectLabel(tenantData.tenant.compliance.industryType, field.options);
                }
            } else if (field.id === "companyType") {
                field.options = checkCompanyTypes?.companyType || [];
                if (tenantData?.tenant?.compliance?.companyType) {
                    field.value = this.getSelectLabel(tenantData.tenant.compliance.companyType, field.options);
                }
            }
        });
        this.setState({ checkIntegrationFields: checkIntegrationFields });
    }


    getCompanyFields(countryCode) {
        const companyFields = [
            {
                id: 'organizationName',
                title: 'Company Name',
                type: INPUT_TYPE.TEXT,
                validation: [["required"]],
                readOnly: true
            },
            {
                id: 'contactNumber',
                title: 'Contact Number',
                type: INPUT_TYPE.TEXT,
            }
        ];

        let countrySpecific = [];
        switch (countryCode) {
            case COUNTRY.US:
                let legalEntityName = {
                        id: 'legalEntityName',
                        title: 'Legal Entity Name',
                        type: INPUT_TYPE.TEXT,
                        validation: [["required"]]
                }
                countrySpecific = []
                break;
        }

        return [...companyFields, ...countrySpecific];
    }

    getComplianceFields(countryCode) {
        let compliance = [];
        switch (countryCode) {
            case COUNTRY.IN:
                compliance = [
                    {
                        id: 'pan',
                        title: 'PAN',
                        type: "MASK_INPUT",
                        validation: [["required"], ["pattern", PAN_REGEX_PATTERN]],
                        tooltip: `The PAN number should follow the pattern <br> ${PAN_NUMBER_MASK} where S-Alphabet 0-Number`
                    },
                    {
                        id: 'tan',
                        title: 'TAN',
                        type: INPUT_TYPE.TEXT,
                        validation: [["pattern", TAN_REGEX_PATTERN]],
                        tooltip: `The TAN number should follow the pattern <br> ${TAN_NUMBER_MASK} where S-Alphabet 0-Number`
                    },
                    {
                        id: 'tds',
                        title: 'TDS Circle/AO Code',
                        type: INPUT_TYPE.TEXT,
                        validation: [["required"], ["pattern", TDS_REGEX_PATTERN]],
                        tooltip: `The TDS Circle/AO Code number should follow the <br>pattern ${TDS_CIRCLE_MASK} where S-Alphabet 0-Number`
                    }
                ];
                break;
        }

        return compliance;
    }

    getExtraFields(countryCode) {
        let extraFields = [];

        switch (countryCode) {
            case COUNTRY.IN:
                extraFields = [
                    {
                        id: 'isWorkLocation',
                        title: 'This is work location',
                        type: INPUT_TYPE.CHECKBOX
                    }
                ];
                break;
        }

        return extraFields;
    }

    

    getCompanyDetails() {
        const tenantData = TenantManager.getPeopleTenantData();
        if (tenantData && tenantData.status === "OK") {
            this.updateState("companyData", tenantData.tenant);
            this.setCompanyDetails(tenantData.tenant);
            TenantService.set(TENANT.IS_DIRECT_PAY_ENABLED, tenantData?.tenant?.isAddBankAcc);
            
            TenantService.set(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED, tenantData?.tenant?.isAttendanceAttachmentsEnabled);
            TenantService.set(TENANT.CUSTOM_FIELD_SECTION_ENABLED, tenantData?.tenant?.customSectionFieldsEnabled);
            TenantService.set(TENANT.PROGRESS_EMPLOYEE_PROFILE_SAVE_BTN, tenantData?.tenant?.progressEmployeeProfileSaveButton);
            TenantService.set(TENANT.PW_REGION, tenantData?.tenant?.pwRegion);
            TenantService.set(TENANT.IS_PW_CONTRACTOR, tenantData?.tenant?.isContractor);
        } else {
            showLoader();
            CompanyDetailService.getCompanyDetail().then(
                (response) => {
                    removeLoader();

                    TenantManager.setPeopleTenantData(response);
                    if (response && response.status === "OK") {
                        this.updateState("companyData", response.tenant);
                        this.setCompanyDetails(response.tenant);
                        TenantService.set(TENANT.IS_DIRECT_PAY_ENABLED, tenantData?.tenant?.isAddBankAcc);
                        
                        TenantService.set(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED, tenantData?.tenant?.isAttendanceAttachmentsEnabled);
                        TenantService.set(TENANT.CUSTOM_FIELD_SECTION_ENABLED, tenantData?.tenant?.customSectionFieldsEnabled);
                        TenantService.set(TENANT.PROGRESS_EMPLOYEE_PROFILE_SAVE_BTN, tenantData?.tenant?.progressEmployeeProfileSaveButton);
                        TenantService.set(TENANT.PW_REGION, tenantData?.tenant?.pwRegion);
                        TenantService.set(TENANT.IS_PW_CONTRACTOR, tenantData?.tenant?.isContractor);
                    }
                }, (error) => {
                    removeLoader();
                }
            );
        }
    }

    getBankDetails() {
        CompanyDetailService.getBankDetail({accountType:ACCOUNT_TYPE.BANK}).then(res=>{
            if(res && res.bankAccounts && res.bankAccounts.length !=0) {
                let bankDetail = res.bankAccounts[0];
                this.isBankObjectId = bankDetail.id
                this.bankFields.forEach(field=>{
                    this.state[field].value = bankDetail[field];
                    this.state[field].isValid = !Utility.isEmpty(bankDetail[field])
                })
                this.setState({...this.state})
            }
        },error=>{
            console.log(error)
        })
    }

    getSelectValueIndex(v, o) {
        let value = [0];

        const index = o.findIndex(i => i.label === v);
        if (index !== -1) {
            value = [index];
        }

        return value;
    }

    getSelectLabel(v, o) {
        let value = v;

        const index = o.findIndex(i => i.value === v);
        if (index !== -1) {
            value = o[index].label;
        }

        return value;
    }

    getFields() {
        let group = {
            companyFields: [...this.state.companyFields],
            complianceFields: [...this.state.complianceFields],
            extraFields: [...this.state.extraFields],
            addressFields: [...this.state.addressFields],
            autoClockOut: this.state.autoClockOut,
            timesheetPastDateRestrictionSet: this.state.timesheetPastDateRestrictionSet,
            timesheetReminderEnabled: this.state.timesheetReminderEnabled,
            timesheetReminderConfig: this.state.timesheetReminderConfig,
            timesheetReminderCCAdmin: this.state.timesheetReminderCCAdmin,
        }
        if (isUSCompliance() && this.state.checkIntegrationFields) group['checkIntegrationFields'] = [...this.state.checkIntegrationFields]
        if(this.state.customSectionFieldsEnabled) {
            group['pwRegionField'] = {
                id: "pwRegion",
                title: "PW Region",
                type: INPUT_TYPE.DROPDOWN,
                value: this.getSelectValue(this.state.pwRegion,this.countryList),
                validation: [["required"]],
                options: this.countryList,
                tooltip: ""
            }
        }
        return group

    }

    getSectionFields(section) {
        const fields = {};
        switch (section) {
            case SECTION.COMPANY_DETAILS:
                fields["companyFields"] = [...this.state.companyFields];
                fields["complianceFields"] = [...this.state.complianceFields];
                fields["extraFields"] = [...this.state.extraFields];
                if (isUSCompliance()) fields["checkIntegrationFields"] = [...this.state.checkIntegrationFields];
                break;
            case SECTION.CONTACT_DETAILS:
                fields["addressFields"] = [...this.state.addressFields];
                break;
        }

        return fields;

    }

    setCompanyDetails(companyData) {
        const data = {
            organizationName: companyData.organizationName,
            contactNumber: companyData.contactNumber,
            isWorkLocation: companyData.isWorkLocation,
            legalEntityName: companyData.legalEntityName,
            companyEmail: companyData.companyEmail,
            ...companyData.compliance,
            ...companyData.address,
            locationType: companyData.locationType,
            autoClockOutDuration: companyData?.autoClockOutDuration,
            timesheetReminder: companyData?.noOfDaysAfterWhichNeedsReminder
        };
        this.setState({ isAddBankAcc: companyData.isAddBankAcc});
        this.setState({ payrunCalcCriteria: companyData.payrunCalcCriteria == "" ? PAYRUN_CALC_CRITERIAS.NO_OF_DAYS_WORKED : companyData.payrunCalcCriteria});
        this.setState({ companyEmailId: companyData.companyEmail});
        this.setState({ isLocationActive: companyData.isLocationActive });
        this.setState({ isAutoClockOutEnabled: companyData?.isAutoClockOut});
        this.setState({ isAttendanceAttachmentsEnabled: companyData?.isAttendanceAttachmentsEnabled});
        this.setState({ timesheetPastDateRestrictionSet: companyData?.timesheetPastDateRestrictionSet});
        this.setState({ timesheetRestrictionConfig: {...this.state.timesheetRestrictionConfig, value:companyData?.timesheetAllowedPastDays}});
        this.setState({ timesheetReminderEnabled: companyData?.timesheetReminderEnabled});
        this.setState({ timesheetReminderCCAdmin: companyData?.timesheetReminderCCAdmin});
        this.setState({ customSectionFieldsEnabled: companyData?.customSectionFieldsEnabled});
        this.setState({ isContractor: companyData?.isContractor});
        this.setState({ pwRegion: companyData?.pwRegion});
        this.setState({ progressEmployeeProfileSaveButton: companyData?.progressEmployeeProfileSaveButton});
        this.setState({ timesheetReminderConfig: {...this.state.timesheetReminderConfig, value:companyData?.noOfDaysAfterWhichNeedsReminder}});

        if(isUSCompliance()) {
            let checkNumber = Object.assign({},this.state.checkNumber)
            checkNumber['canValidate'] = true
            checkNumber['value'] = (companyData.checkNumber)
            if(this.state.isAddBankAcc && ((companyData.checkNumber == Utility.STRING_EMPTY) || (!Utility.isValidNumber(companyData.checkNumber) && ( (companyData.checkNumber.length > this.state.checkNumber.validation.max))))){
                checkNumber['isValid'] =  false
            } else {
                checkNumber['isValid'] =  true
            }
            this.setState({ checkNumber: checkNumber}); 
        }

        if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED) && companyData.pwRegion) {
            data["country"] = companyData.pwRegion;
            const pwRegionField = {...this.state.pwRegionField}
            pwRegionField['value'] = this.getSelectLabel(companyData.pwRegion, this.countryList);
            this.setState({ pwRegionField: pwRegionField });
        }

        const fields = this.getFields();

        Object.entries(fields).forEach(([key, state]) => {
            if (state && Array.isArray(state)) {
                state.forEach((field) => {
                    this.updateFieldConfigs(field, data[field.id]);
                    switch (field.type) {
                        case INPUT_TYPE.DROPDOWN:
                            field.value = this.getSelectLabel(data[field.id], field.options);
                            break;
                        case INPUT_TYPE.DATE:
                            field.value = reverseTimezoneOffset(data[field.id]);
                            break;
                        default:
                            field.value = data[field.id];
                            break;
                    }
                });
                this.updateState(key,  state);
            } else if(state && typeof state === "object") {
                if (state.type === INPUT_TYPE.DROPDOWN) {
                  state.value = this.getSelectLabel(
                    data[state.id],
                    state.options
                  );
                } else {
                  state.value = data[state.id];
                }
                this.updateState(key, state);
            }
        });
        this.workweek = companyData?.workWeekDetails ? companyData?.workWeekDetails : this.workweek;
        this.getWorkWeekSequence(this.workweek);
    }
    getWorkWeekSequence(workWeek) {
        let sequenceWeek = []
        WORKWEEK_SEQUENCE.forEach(ws=>{
            let ind = workWeek.findIndex(ww=>ww?.day?.toLocaleLowerCase()==ws?.name?.toLocaleLowerCase())
            if(ind != -1) {
                sequenceWeek[ws.sequence]=(workWeek[ind])
            }
        })
        this.workweek = sequenceWeek;
    }
    isInvalid(section) {
        let invalid = false;

        const fields = section === SECTION.ALL ? this.getFields() : this.getSectionFields(section);

        Object.entries(fields).forEach(([key, state]) => {
            if (state && Array.isArray(state)) {
                state.forEach((field) => {
                    const error = this.hasError(field, field.value);
                    field.invalid = error.invalid;
                    field.errorMsg = error.errorMsg;

                    if (field.invalid) {
                        invalid = true;
                    }
                });

                this.updateState(key,  state);
            }
        });
        if (this.state.isAddBankAcc && this.state.companyEmailId === Utility.STRING_EMPTY) {
            invalid = true;
        } else if(isUSCompliance() && this.state.isCheckPrint && (!this.state.checkNumber.isValid || (this.state.checkNumber.value.length < this.state.checkNumber.validation.max))){
            invalid = true;
        }
        if(this.state.isAddBankAcc && isUSCompliance()) {
            this.bankFields.forEach(field=>{
                if(this.state[field] && !this.state[field].isValid) {
                    invalid = true;
                    this.state[field].canValidate = true
                }
            })
        }
        if (this.state.timesheetPastDateRestrictionSet && (this.state.timesheetRestrictionConfig.value === Utility.STRING_EMPTY || 
                parseInt(this.state.timesheetRestrictionConfig.value) > 365 || !Number.isInteger(parseFloat(this.state.timesheetRestrictionConfig.value)) || 
                parseInt(this.state.timesheetRestrictionConfig.value) < 0)) {
                invalid = true;
        }
        if (this.state.timesheetReminderEnabled && (this.state.timesheetReminderConfig.value === Utility.STRING_EMPTY || 
                parseInt(this.state.timesheetReminderConfig.value) > 30 || !Number.isInteger(parseFloat(this.state.timesheetReminderConfig.value)) ||
                parseInt(this.state.timesheetReminderConfig.value) < 0)) {
                invalid = true;
        }
        if (section === SECTION.ALL || section === SECTION.CUSTOM_FIELD_SECTION_ENABLED) {
            if(this.state.customSectionFieldsEnabled && Utility.isEmpty(this.state.pwRegionField.value)) {
                invalid = true;
                showAlert('Please select PW Region',`Please select PW Region country under ${SECTION.CUSTOM_FIELD_SECTION_ENABLED} Section`);
            }
        }
        return invalid;
    }

    getSelectValue(v, o) {
        let value = v;

        const index = o.findIndex(i => i.label === v);
        if (index !== -1) {
            value = o[index].value;
        }

        return value;
    }

    enrichPayload(payload, fields) {
        fields.forEach((field) => {
            switch (field.type) {
                case INPUT_TYPE.DROPDOWN:
                    payload[field.id] = this.getSelectValue(field.value, field.options);
                    break;
                case INPUT_TYPE.CHECKBOX:
                    payload[field.id] = !!field.value;
                    break;
                case INPUT_TYPE.DATE:
                    payload[field.id] = convertDateToJson(field.value);
                    break;
                default:
                    payload[field.id] = field.value;
                    break;
            }
        });
    }

    getCompliancePayload(complianceData) {
        const compliance = complianceData ? {...complianceData} : {};

        switch (this.state.countryCode) {
            case COUNTRY.IN:
                compliance["@type"] = "type.googleapis.com/v1.INTenantCompliance";
                compliance["countryCode"] = this.state.countryCode;
                break;
            case COUNTRY.US:
                compliance["@type"] = "type.googleapis.com/v1.USTenantCompliance";
                compliance["countryCode"] = this.state.countryCode;
                break;
            default:
                compliance["@type"] = "type.googleapis.com/v1.DefaultCompliance";
                compliance["countryCode"] = this.state.countryCode;
                break;
        }

        this.enrichPayload(compliance, this.state.complianceFields);

        return compliance;
    }



    update(section) {
        if (this.isInvalid(section)) {
            return;
        }

        if (section === SECTION.ALL){
            showLoader("Updating... Please wait");
        } else {
            showLoader(`Updating ${section}... Please wait`);
        }

        switch (section) {
            case SECTION.DATE_FORMAT:
            case SECTION.DECIMAL_PLACES:
                this.getTenantConfig(section);
                break;
            case SECTION.ALL:
                this.getTenantConfig(section);
                this.updateTenantData(section);
                break;
            default:
                this.updateTenantData(section);
                break;
        }
    }

    updateTenantData(section) {
        const payload = this.getPayload(section);

        CompanyDetailService.updateCompanyDetail(payload).then(
            (response) => {
                if (response && response['status'] === "OK") {
                    TenantManager.setPeopleTenantData(response);
                    removeLoader();

                    if (response['tenant']['workWeekDetails']) {
                        TenantService.set(TENANT.TENANT_WORK_WEEK, response['tenant']['workWeekDetails']);
                    }

                    TenantService.set(TENANT.DATE_OF_CREATION, response['tenant']['dateOfCreation']);
                    TenantService.set(TENANT.COUNTRY_CODE, response['tenant']['countryCode']);
                    TenantService.set(TENANT.CURRENCY_CODE, response['tenant']['currency']);
                    TenantService.set(TENANT.ORGANIZATION_NAME, response['tenant']['organizationName']);
                    TenantService.set(TENANT.IS_DIRECT_PAY_ENABLED, response['tenant']['isAddBankAcc']);
                    TenantService.set(TENANT.IS_CHECKHQ_INTEGRATION, response['tenant']['checkHQIntegration']);
                    TenantService.set(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED, response['tenant']['isAttendanceAttachmentsEnabled']);
                    TenantService.set(TENANT.IS_CHECKHQ_COMPANY_CREATED, response['tenant']['checkHQCompanyCreated']);
                    TenantService.set(TENANT.ADDRESS, response['tenant']['address']);
                    TenantService.set(TENANT.STATE_CODE, response['tenant']['address'] ? response['tenant']['address']['state'] : "");
                    TenantService.set(TENANT.CUSTOM_FIELD_SECTION_ENABLED, response['tenant']['customSectionFieldsEnabled']);
                    TenantService.set(TENANT.PROGRESS_EMPLOYEE_PROFILE_SAVE_BTN, response['tenant']['progressEmployeeProfileSaveButton']);
                    TenantService.set(TENANT.IS_PW_CONTRACTOR, response['tenant']['isContractor']);
                    TenantService.set(TENANT.PW_REGION, response['tenant']['pwRegion']);
                    LeftMenuUpdate.sendMessage(true);

                    if (section !== SECTION.ALL) {
                        showToast(`${section} updated successfully.`, TOAST_TYPE.SUCCESS);
                    } else {
                        showToast("Company details updated successfully.", TOAST_TYPE.SUCCESS);
                    }

                    ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.COMPANY_DETAILS).then(
                        (setupResponse) => {
                            TenantManager.setProfileData(setupResponse['profileStages']);
                        }
                    );

                    if (this.props.renderAsStep) {
                        this.props.onSaveAndNext();
                    } else if(isUSCompliance()) {
                        RouteManager.navigateToHome();
                    }
                } else {
                    removeLoader();
                    if (response && response['tenant'] && response['tenant']["checkHqError"]) {
                        showToast(response['tenant']["checkHqError"]["message"], TOAST_TYPE.FAILURE);
                    }
                }
            }, (error) => {
                removeLoader();
                showToast("Internal Server Error", TOAST_TYPE.FAILURE);
            }
        );

        if (isUSCompliance() && this.state.isAddBankAcc) {
            this.saveBank();
        }
    }
    getPayload(section) {
        const payload = this.state.companyData;

        if (section === SECTION.ALL || section === SECTION.COMPANY_DETAILS) {
            this.enrichPayload(payload, this.state.companyFields);
            this.enrichPayload(payload, this.state.extraFields);
            payload["compliance"] = this.getCompliancePayload(payload["compliance"]);
            this.enrichPayload(payload["compliance"], this.state.checkIntegrationFields);
            payload["phone"] = payload["contactNumber"];
        }

        if (section === SECTION.ALL || section === SECTION.CONTACT_DETAILS) {
            const address = {};
            this.enrichPayload(address, this.state.addressFields);
            payload["address"] = address;

            if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
                payload["address"]["country"] = this.state.countryCode;
            }
        }

        if (section === SECTION.ALL || section === SECTION.CHECK_PRINTING) {
            payload["isAddBankAcc"] = this.state.isAddBankAcc;
            payload["companyEmail"] = this.state.isAddBankAcc ? this.state.companyEmailId : Utility.STRING_EMPTY;

            if(isUSCompliance() && this.state.isAddBankAcc) {
                payload['checkNumber'] = this.state.isAddBankAcc ? parseInt(this.state.checkNumber.value):Utility.STRING_EMPTY;
            }
        }
        payload["payrunCalcCriteria"] = this.state.payrunCalcCriteria;
        payload["autoClockOutDuration"] = parseFloat(this.getSelectValue(this.state.autoClockOut.value,AUTO_CLOCK_TIME_DURATION));
        payload["companyTimeZone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
        payload["isAutoClockOut"] = this.state.isAutoClockOutEnabled;
        payload["isAttendanceAttachmentsEnabled"] = this.state.isAttendanceAttachmentsEnabled;
        payload["timesheetPastDateRestrictionSet"] = this.state.timesheetPastDateRestrictionSet;
        payload["timesheetAllowedPastDays"] = parseInt(this.state.timesheetRestrictionConfig.value);
        payload["timesheetReminderEnabled"] = this.state.timesheetReminderEnabled;
        payload["timesheetReminderCCAdmin"] = this.state.timesheetReminderCCAdmin;
        payload["noOfDaysAfterWhichNeedsReminder"] = parseInt(this.state.timesheetReminderConfig.value);
        payload["customSectionFieldsEnabled"] = this.state.customSectionFieldsEnabled;
        payload["progressEmployeeProfileSaveButton"] = this.state.progressEmployeeProfileSaveButton;
        payload["isContractor"] = this.state.isContractor;
        payload["pwRegion"] = this.getSelectValue(this.state.pwRegionField.value,this.countryList);
        return payload;
    }

    getPayloadForBank() {
        let payload = {
            accountType: ACCOUNT_TYPE.BANK
        };
        this.bankFields.forEach(field=>{
            payload[field] = this.state[field].value.trim()
        })
        return payload;
    }

    saveBank() {
        if(this.isBankObjectId) {
            CompanyDetailService.updateBankDetail(this.getPayloadForBank(),this.isBankObjectId).then(res=>{
                
            },error=>{
                showToast(i18next.t("UPDATE_BANK_ERROR"),TOAST_TYPE.FAILURE)
            })
        } else {
            CompanyDetailService.addBankAccount(this.getPayloadForBank()).then(res=>{
                
            },error=>{
                showToast(i18next.t("ADD_BANK_ERROR"),TOAST_TYPE.FAILURE)
            })
        }
    }

    getSampleDate() {
        const format = this.getSelectLabel(this.state.dateFormat.value, this.state.dateFormat.options);
        return Utility.formatDate(moment().format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY, format);
    }

    getSampleAmount() {
        const decimalPlaces = this.getSelectLabel(this.state.decimalFormat.value, this.state.decimalFormat.options);
        return FormatCurrencyService.format(1000, decimalPlaces);
    }

    changeLanguage(data) {
        const prevValue = this.state.language.value;

        this.setState({
            language: {
                ...this.state.language,
                value: data.title
            }
        });
        if (i18n.language !== data.code) {
            showAlert(
                "Change Language?",
                `<div class="mb-l">You will be redirected to Dashboard in order to reflect language changes.</div>`,
                [
                    {
                        title: "Cancel",
                        className: "mr-m",
                        onClick: () => {
                            this.setState({
                                language: {
                                    ...this.state.language,
                                    value: prevValue
                                }
                            });
                        }
                    },
                    {
                        title: "Ok",
                        className: "bg-app text-white",
                        onClick: () => {
                            i18n.changeLanguage(data.code);
                            localStorage.setItem(LANG, data.code);
                            RouteManager.navigateToHome();
                        }
                    }
                ]
            );
        }
    }

    getTenantConfig(section) {
        const tenantConfig = TenantService.get(TENANT.CONFIG);
        if (!tenantConfig.confId) {
            CompanyDetailService.getTenantConfig().then(
                (response) => {
                    if (response) {
                        TenantService.set(TENANT.CONFIG, response);
                        CompanyDetailService.setDateFormat(response['dateFormat']);
                        CompanyDetailService.setDecimalFormat(response['decimalFormat']);
                        CompanyDetailService.setGeoFencing(response['geofencing']);
                        this.updateTenantConfig(section);
                    }
                }, (error) => {
                    if (TenantService.get(TENANT.COUNTRY_CODE) === COUNTRY.US) {
                        CompanyDetailService.setDateFormat(FORMAT.MMDDYYYY);
                    } else {
                        CompanyDetailService.setDateFormat(FORMAT.DDMMYYYY);
                    }
                }
            );
        } else {
            this.updateTenantConfig(section);
        }
    }

    updateTenantConfig(section) {
        const tenantConfig = TenantService.get(TENANT.CONFIG);

        const payload = {
            ...tenantConfig,
            countryCode: tenantConfig.countryCode,
            tenantId: tenantConfig.tenantId,
            confId: tenantConfig.confId,
            dateFormat: this.getSelectValue(this.state.dateFormat.value, this.state.dateFormat.options),
            decimalFormat: this.parseDecimalFormatField(this.getSelectValue(this.state.decimalFormat.value, this.state.decimalFormat.options))
        };

        CompanyDetailService.updateTenantConfig(payload).then(
            (response) => {
                removeLoader();
                
                if (section !== SECTION.ALL) {
                    removeLoader();
                    showToast(`${section} updated successfully.`, TOAST_TYPE.SUCCESS);
                }
                if (response) {
                    
                    TenantService.set(TENANT.CONFIG, response);
                    CompanyDetailService.setDecimalFormat(response.decimalFormat);
                    CompanyDetailService.setGeoFencing(response['geofencing']);
                    CompanyDetailService.setDateFormat(response.dateFormat);
                }
            },
            (error) => {
                removeLoader();
                CompanyDetailService.setDateFormat(tenantConfig.dateFormat);
                CompanyDetailService.setDecimalFormat(tenantConfig.decimalFormat);
                CompanyDetailService.setGeoFencing(tenantConfig['geofencing']);
                if (section !== SECTION.ALL) {
                    removeLoader();
                    showToast("Internal Server Error", TOAST_TYPE.FAILURE);
                }
            }
        );
    }

    parseDecimalFormatField = (value) => {
        try{
            if(!Utility.isEmpty(value)) return parseInt(value);
            const decimalPlaces = TenantService.get(TENANT.DECIMAL_FORMAT)
            return parseInt(decimalPlaces);            
        }catch(err) {
            const decimalPlaces = TenantService.get(TENANT.DECIMAL_FORMAT)
            return parseInt(decimalPlaces);
        }
    }

    isRequired(validation) {
        return validation ? validation.findIndex((v) => v[0] === "required") !== -1 : false;
    }

    getTooltip(tooltip) {
        return (
            <div className="position-absolute" style={{ height: "20px", width: "20px", right: "22px", top: "37px" }}>
                <ReactTooltip type="dark" place="right" html={true} effect='solid' />
                <span data-tip={tooltip}>
                    <DKIcon className="ic-s-2" src={ic_info_warning} />
                </span>
            </div>
        )
    }

    hasError(field, value) {
        let error = {
            invalid: false,
            errorMsg: null
        };

        const validation = field.validation;

        if (validation && validation.length !== 0) {
            validation.forEach((validation) => {
                switch (validation[0]) {
                    case "required":
                        if (value === null || value === undefined || String(value).trim() === "") {
                            error.invalid = true;
                        }
                        break;
                    case "pattern":
                        if (value && !new RegExp(validation[1]).test(value)) {
                            error.invalid = true;
                            error.errorMsg = "Invalid " + field.title;
                        }
                        break;
                    case "integerOnly":
                        if (String(value).trim() !=="" && !Number.isInteger(parseFloat(value))) {
                            error.invalid = true;
                            error.errorMsg = "Only Integer values are allowed";
                        } 
                        break;
                    case "365days":
                        if (String(value).trim() !=="" && parseInt(value) > 365) {
                            error.invalid = true;
                            error.errorMsg = "Upto 365 days are allowed only";
                        } else if (parseInt(value) < 0) {
                            error.invalid = true;
                            error.errorMsg = "Days cannot be less than 0";
                        }
                        break;
                    case "30days":
                        if (String(value).trim() !=="" && parseInt(value) > 30) {
                            error.invalid = true;
                            error.errorMsg = "Upto 30 days are allowed only";
                        } else if (parseInt(value) < 0) {
                            error.invalid = true;
                            error.errorMsg = "Days cannot be less than 0";
                        }
                        break;        
                }
            });
        }

        return error;
    }

    showPatternError(validation, errorMsg, value) {
        if (value !== null && value !== undefined && String(value).length !== 0) {
            const pattern = validation.findIndex((v) => v[0] === "pattern") !== -1;

            return pattern && (
                <DKLabel
                    className="p-h-l fs-s text-red"
                    style={{
                        marginTop: "-12px"
                    }}
                    text={errorMsg}
                />
            )
        }
    }

    updateState(stateName, state) {
        this.setState({
            [stateName]: state
        }, () => {
            this.setState({
                count: this.state.count + 1
            });
        });
    }

    updateValue(stateName, index, value) {
        let state;

        if (index !== -1) {
            state = [...this.state[stateName]];
            state[index] = {...state[index], value: value, ...this.hasError(state[index], value)};
        } else {
            state = {...this.state[stateName]};
            state = {...state, value: value, ...this.hasError(state, value)};
        }

        this.updateState(stateName, state);
    }

    getField(state, field, index, width) {
        switch (field.type) {
          case INPUT_TYPE.TEXT:
          case INPUT_TYPE.NUMBER:
          case INPUT_TYPE.EMAIL:
          case INPUT_TYPE.DATE:
            return (
              <div key={field.id} style={{ flex: "0 0 50%", maxWidth: width }}>
                <div className="row pb-l p-h-l position-relative">
                  <DKInput
                    title={field.title}
                    type={field.type}
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    options={field.options}
                    value={field.value}
                    errorMessage={field.errorMsg}
                    readOnly={field.readOnly || !this.state.hasEditAccess ? true : false}
                    required={this.isRequired(field.validation)}
                    invalid={field.invalid}
                    tooltip={{
                      content: field.tooltip,
                      className: "warning-tooltip-prop",
                    }}
                    validator={(value)=>{
                        return !field.invalid
                    }}
                    canValidate={field.invalid}
                    onChange={(value) => {
                      this.updateValue(state, index, value);
                    }}
                  />
                </div>
                {field.invalid &&
                  this.showPatternError(
                    field.validation,
                    field.errorMsg,
                    field.value
                  )}
              </div>
            );
          case INPUT_TYPE.DROPDOWN:
            return (
              <div key={field.id} style={{ flex: "0 0 50%", maxWidth: width }}>
                <div className="row pb-l p-h-l position-relative">
                  <DKInput
                    title={field.title}
                    type={INPUT_TYPE.DROPDOWN}
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    dropdownConfig={{
                      allowSearch: field.options?.length > 3,
                      searchableKey: "label",
                      data: field.options,
                      renderer: (i, item) => item.label,
                      onSelect: (i, value) => {
                        this.updateValue(state, index, value.label);
                      },
                    }}
                    value={field.value}
                    errorMessage={field.errorMsg}
                    readOnly={field.readOnly || !this.state.hasEditAccess}
                    required={this.isRequired(field.validation)}
                    invalid={field.invalid}
                    canValidate={field.invalid}
                    onChange={() => {}}
                    tooltip={{
                        content: field.tooltip,
                        className: "warning-tooltip-prop",
                    }}
                  />
                  {/* {field.tooltip && this.getTooltip(field.tooltip)} */}
                </div>
                {field.invalid &&
                  this.showPatternError(
                    field.validation,
                    field.errorMsg,
                    field.value
                  )}
              </div>
            );
          case "LANGUAGE_FIELD":
            return (
              <div key={field.id} style={{ flex: "0 0 50%", maxWidth: width }}>
                <div className="row pb-l p-h-l position-relative">
                  <DKInput
                    title={field.title}
                    type={INPUT_TYPE.DROPDOWN}
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    dropdownConfig={{
                      allowSearch: field.options?.length > 7,
                      data: field.options,
                      renderer: (i, item) => {
                        return (
                          <div
                            key={i}
                            className="row listPickerBG cursor-hand parent-width border-box"
                          >
                            <DKIcon src={item.icon} className="ic-r circle" />
                            <DKLabel text={item.title} className="ml-r" />
                          </div>
                        );
                      },
                      onSelect: (i, value) => {
                        this.changeLanguage(value);
                        // this.updateValue(state, index, value.title);
                      },
                    }}
                    value={field.value}
                    errorMessage={field.errorMsg}
                    readOnly={field.readOnly || !this.state.hasEditAccess}
                    required={this.isRequired(field.validation)}
                    invalid={field.invalid}
                    canValidate={field.invalid}
                    onChange={() => {}}
                  />
                  {field.tooltip && this.getTooltip(field.tooltip)}
                </div>
                {field.invalid &&
                  this.showPatternError(
                    field.validation,
                    field.errorMsg,
                    field.value
                  )}
              </div>
            );
          case INPUT_TYPE.CHECKBOX:
            return (
              <div key={field.id} style={{ flex: "0 0 50%", maxWidth: width }}>
                <div className="row p-h-l position-relative parent-height">
                  <DKCheckMark
                    className="pt-s"
                    isSelected={field.value}
                    color="bg-app"
                    onClick={() => {
                        if(this.state.hasEditAccess) {

                            this.updateValue(state, index, !field.value);
                        }
                    }}
                  />
                  <DKLabel className="pt-s pl-xs" text={field.title} />

                  {field.tooltip && this.getTooltip(field.tooltip)}
                </div>
                {field.invalid &&
                  this.showPatternError(
                    field.validation,
                    field.errorMsg,
                    field.value
                  )}
              </div>
            );
          case "MASK_INPUT":
              return (
                <div key={field.id} style={{ flex: "0 0 50%", maxWidth: width }}>
                    <div className="row pb-l p-h-l position-relative">
                        <MaskInput
                            title={field.title}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            value={field.value}
                            errorMessage={field.errorMsg}
                            readOnly={field.readOnly ? true : false}
                            required={this.isRequired(field.validation)}
                            invalid={field.invalid}
                            tooltip={{
                                content: field.tooltip,
                                className: "warning-tooltip-prop",
                            }}
                            canValidate={field.invalid}
                            onChange={(value) => {
                                this.updateValue(state, index, value);
                            }}
                        />
                    </div>
                </div>
              );
        }
    }

    renderCompanyFields() {
        return this.state.companyFields.map((field, index) => this.getField("companyFields", field, index, "50%"));
    }

    renderComplianceFields() {
        return this.state.complianceFields.map((field, index) => this.getField("complianceFields", field, index, "50%"));
    }

    renderExtraFields() {
        return this.state.extraFields.map((field, index) => this.getField("extraFields", field, index, "50%"));
    }

    renderAutoClockOutFields() {
        return this.state.autoClockOut.map((field, index) => this.getField("autoClockOut", field, index, "50%"));
    }

    getUSEmailSpecificFields() {
        return (
            <div >
                <DKLine className="bg-line-2" />
                <div className="p-l">
                    <div className="p-h-l position-relative">
                    <div className="row parent-width">
                            <Toggle
                                className="mr-s border-n"
                                isOn={this.state.isAddBankAcc}
                                onChange={()=>{
                                    if(this.state.hasEditAccess) {
                                        this.addBankAccToggle.bind(this)
                                    }
                                }}
                            />
                            <span className="">Enable Direct Payouts and Check Printing</span>
                            <DKTooltipWrapper 
                            tooltipClassName={"warning-tooltip-prop"}
                            content="Please add the bank account to utilize the <br> Direct Deposit and Check printing features.">
                            
                            <div className="ml-m mt-xs">
                                
                                <span >
                                    <DKIcon className="ic-s-2" src={ic_info_warning} />
                                </span>
                            </div>
                            </DKTooltipWrapper>
                        </div>
                        {this.state.isAddBankAcc && <div className="row pb-l mt-xl parent-width">
                        <div className="pr-l" style={{width:"48%"}}>
                            {this.state.isAddBankAcc && <DKInput
                                title="Company Email Id"
                                type={INPUT_TYPE.EMAIL}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                required={true}
                                errorMessage="Please enter correct email address"
                                value={this.state.companyEmailId}
                                canValidate={true}
                                onChange={(value) => {
                                    this.state.companyEmailId = value
                                }}
                                readOnly={!this.state.hasEditAccess}
                            />}
                        </div>
                        <div className=" pl-l" style={{width:"48%"}}>
                             
                        </div>
                        </div>}
                        {
                            this.state.isAddBankAcc && <div className="d-flex ">
                                <div className="pr-l" style={{width:"48%"}}>
                                <DKInput
                                title={i18next.t('BANK_NAME')}
                                className="pb-l"
                                readOnly={!this.state.hasEditAccess}
                                type={this.state.bank.type}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                required={this.state.bank.validation.require}
                                value={this.state.bank.value}
                                canValidate={this.state.bank.canValidate}
                                onChange={(value) => {
                                    this.state.bank.value = value;
                                    this.state.bank.isValid = !Utility.isEmpty(value)
                                    this.setState({
                                        bank:{
                                            ...this.state.bank,
                                            canValidate: true
                                        }
                                    })
                                }}
                                
                            />
                            <DKInput
                                title={i18next.t("BANK_ACCOUNT_NUMBER")}
                                className="pb-l"
                                type={this.state.accountNumber.type}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                required={this.state.accountNumber.validation.require}
                                value={this.state.accountNumber.value}
                                canValidate={this.state.accountNumber.canValidate}
                                validator={(value)=>{
                                    
                                    if(Utility.isEmpty(value)) {
                                        this.state.accountNumber.isValid = false;
                                        return false;
                                    } else if(value.length < this.state.accountNumber.validation.min || value.length > this.state.accountNumber.validation.max) {
                                        this.state.accountNumber.isValid = false;
                                        return false;
                                    } else {
                                        this.state.accountNumber.isValid = true;
                                        return true;
                                    }
                                    
                                }}
                                onChange={(value) => {
                                    this.state.accountNumber.value = value.trim();
                                    this.setState({
                                        accountNumber:{
                                            ...this.state.accountNumber,
                                            canValidate: true
                                        }
                                    })
                                }}
                                tooltip = {{
                                    "content" : i18next.t("ACCOUNT_VALID_MSG"),
                                    "className" : "warning-tooltip-prop"
                                }}
                                readOnly={!this.state.hasEditAccess}
                            />
                            <DKInput
                                title={i18next.t("ROUTING_NUMBER")}
                                className="pb-l"
                                type={this.state.routingNumber.type}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                required={this.state.routingNumber.validation.require}
                                value={this.state.routingNumber.value}
                                canValidate={this.state.routingNumber.canValidate}
                                onChange={(value) => {
                                    this.state.routingNumber.value = value.trim();
                                    this.setState({
                                        routingNumber:{
                                            ...this.state.routingNumber,
                                            canValidate: true
                                        }
                                    })
                                }}
                                validator={(value)=>{
                                    if (this.state.routingNumber.validation.regex) {
                                        const regex = new RegExp(this.state.routingNumber.validation.regex);
                                        this.state.routingNumber.isValid = regex.test(value);
                                        return regex.test(value);
                                    }
                                }}
                                tooltip = {{
                                    "content" : i18next.t("ROUTING_VALID_MSG"),
                                    "className" : "warning-tooltip-prop"
                                }}
                                readOnly={!this.state.hasEditAccess}
                            />
                            <DKInput
                                title={i18next.t("CHECK_NUMBER")}
                                className="pb-l"
                                type={INPUT_TYPE.TEXT}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                required={true}
                                value={this.state.checkNumber.value}
                                canValidate={this.state.checkNumber.canValidate}
                                tooltip = {{
                                    "content" : i18next.t("CHECK_NUMBER_VALID_MSG"),
                                    "className" : "warning-tooltip-prop"
                                }}
                                onChange={(value) => {
                                    this.state.checkNumber.canValidate = true
                                    let val = {
                                        value:value,
                                        canValidate:true
                                    }
                                    if(value.length <= this.state.checkNumber.validation.max && Utility.isValidNumber(value)&& (value != Utility.STRING_EMPTY)) {
                                        val.isValid = true;
                                    } else {
                                        val.isValid = false;
                                        if(value == Utility.STRING_EMPTY) {
                                            this.state.checkNumber.isValid = false
                                        }
                                    }
                                    this.state.checkNumber.value = value
                                    if(value != Utility.STRING_EMPTY){
                                        this.onChangeCheckNumber(val)
                                    }
                                    
                                }}
                                readOnly={!this.state.hasEditAccess}
                            />
                            {((!this.state.checkNumber.isValid)&& this.state.checkNumber.value ) && <DKLabel
                                    className="text-red"
                                    text={i18next.t("CHECK_NUMBER_ERROR")}/>}
                                </div>
                                <div className="pl-l pt-l" style={{width:"48%"}}>
                                    <img src={Cheque} className="parent-width"/>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }


    copyTimeToAll(data,filterWorkingDay) {
        const startTime = data.startTime;
        const endTime = data.endTime;
        const duration = data.duration;
        filterWorkingDay.find(element => {
            element['startTime'] = startTime;
            element['endTime'] = endTime;
            element['duration'] = duration;
        });
        this.setState({
            ...this.state
        })
    }
    setTimeAndDuration(data) {
        const startTime = data.startTime;
        const endTime = data.endTime;
        const startDateFormat = moment.utc(startTime, 'hh:mm A');
        const endDateFormat = moment.utc(endTime, 'hh:mm A');
        const momentStartDate = moment(startDateFormat);
        const momentEndDate = moment(endDateFormat);
        const timeDifference = momentEndDate.diff(momentStartDate);
        const hoursDuration = moment.duration(timeDifference).asHours();
        const duration = (hoursDuration < 0) ? (24 + (hoursDuration)) : hoursDuration;
        data.duration = duration%1 != 0 ? duration.toFixed(2) : duration
        this.setState({
            ...this.state
        })
    }

    enableDisableLocationSettings() {
        const currentState = this.state.isLocationActive;
        this.setState({ isLocationActive: !currentState });
    }

    getLocationOptions() {
        let locationOptions = [];
        LOCATION.forEach((location) => {
          const option = {
            label: location,
            value: location,
          };
          locationOptions.push(option);
        });
        return locationOptions;
    }

    getCPFAccountOrganizationIdName(organizationId) {
        const organizationIdName = ORGANIZATION_IDS.find((org) => {
          return org.id === organizationId;
        });

        if (organizationIdName) {
          return organizationIdName.name;
        }
        return CONSTANTS.EMPTY_STRING;
    }

    addNewACPFAccount() {
        this.setState({
          cpfAccountConfig: {
            isAddCpfenabled: true,
            isEdit: false,
            accountDetails: {},
          },
        });

    }

    editCPFAccount(account) {
        this.setState({
          cpfAccountConfig: {
            isAddCpfenabled: true,
            isEdit: true,
            accountDetails: account,
          },
        });
    }


    deleteCpfEpfRecord(account) {
        showLoader("Delete Account... Please wait");
        CompanyDetailService.deleteCPFAccount(account?.accountId).then(
          (response) => {
            showToast("Account deleted successfully", TOAST_TYPE.SUCCESS);
            this.getCpfEpfAccountDetails();
            removeLoader();
          },
          (error) => {
            showToast("Something went wrong.", TOAST_TYPE.FAILURE);
            removeLoader();
          }
        );
    }

    deleteCPFAccount(account) {
        const deleteMsg = [
          {
            title: "Cancel",
            className: "bg-gray1 border-m",
          },
          {
            title: "Delete",
            className: "bg-red text-white ml-r",
            onClick: () => this.deleteCpfEpfRecord(account),
          },
        ];
        showAlert(
          "Delete CPF Account?",
          "Are you sure you want to delete this CPF Account. This action cannot be undone later.",
          deleteMsg
        );
    }

    onCPFPopUpClose = (isReload) => {
        this.setState({
          cpfAccountConfig: {
            isAddCpfenabled: false,
            isEdit: false,
            accountDetails: {},
          },
        });
        if(isReload) {
            this.getCpfEpfAccountDetails();
        }
    }

    addNewEPFAccount() {
        this.setState({
          epfAccountConfig: {
            isAddEpfenabled: true,
            isEdit: false,
            epfAccountDetails: {},
          },
        });

    }

    editEPFAccount(account) {
        this.setState({
          epfAccountConfig: {
            isAddEpfenabled: true,
            isEdit: true,
            epfAccountDetails: account,
          },
        });
    }

    deleteEPFAccount(account) {
        const deleteMsg = [
          {
            title: "Cancel",
            className: "bg-gray1 border-m",
          },
          {
            title: "Delete",
            className: "bg-red text-white ml-r",
            onClick: () => this.deleteCpfEpfRecord(account),
          },
        ];
        showAlert(
          "Delete EPF Account?",
          "Are you sure you want to delete this EPF Account. This action cannot be undone later.",
          deleteMsg
        );
    }

    onEPFopUpClose = (isReload) => {
        this.setState({
          epfAccountConfig: {
            isAddEpfenabled: false,
            isEdit: false,
            epfAccountDetails: {},
          },
        });
        if(isReload) {
            this.getCpfEpfAccountDetails();
        }
    }

    updateFieldConfigs = (field, value) => {
        switch (getTenantCountryCode()) {
            case COUNTRY.US:
                switch (field.id) {
                    case "state":
                        if(!Utility.isEmpty(value)) {
                            field.readOnly = true;
                        } else {
                            field.readOnly = false;
                        }
                        break;
                }
                break;
        }
    }

    getEPFAccountsSection() {
        return (
          <div className="row">
            <div className="bg-white p-h-xl pt-r pb-l column align-items-center">
              <div>
                <DKIcon
                  src={addIcon}
                  className="ml-s ml-r mt-xs cursor-hand "
                  onClick={() => {
                    this.addNewEPFAccount();
                  }}
                />
              </div>
              <div className="fw-m mt-s">Add New</div>
              <div className="mt-s">Add New EPF Account for your country</div>
            </div>
            <div className="row">
              {this.state?.epfAccounts?.map((account, index) => {
                return (
                  <div className="ml-m bg-white p-h-xl pt-r pb-l border-m border-radius-m border-box dashboard-card column cpf-account-wrapper">
                    <div>
                      <div className="fs-m fw-m">
                        {account.compliance?.epfAccountName}
                      </div>
                      {/* <div>{account.compliance?.submissionNumber}</div> */}
                    </div>
                    <div className="mt-m">
                      <div className="row">
                        <div>EPF Code-</div>
                        <div>{account.compliance?.epfCode}</div>
                      </div>
                      <div className="row fw-m">
                        <div>Employer EPF Number-</div>
                        <div>{account.compliance?.empEpf}</div>
                      </div>
                    </div>
                    <div className="row justify-content-end actionButtons mt-m">
                      <DKIcon
                        src={DKIcons.ic_edit}
                        onClick={() => {
                          this.editEPFAccount(account);
                        }}
                        className="ic-s cursor-hand"
                      />
                      <DKIcon
                        src={DKIcons.ic_delete}
                        onClick={() => {
                          this.deleteEPFAccount(account);
                        }}
                        className="ml-m ic-s cursor-hand"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
    }

    enableDisableAutoClockOut = () => {
        this.setState({
            isAutoClockOutEnabled : !this.state.isAutoClockOutEnabled
        })
    }

    enableDisableTimesheetPastDateRestriction = () => {
        this.setState({
            timesheetPastDateRestrictionSet: !this.state.timesheetPastDateRestrictionSet
        })
    }

    enableDisableTimesheetReminderMail = () => {
        this.setState({
            timesheetReminderEnabled: !this.state.timesheetReminderEnabled
        })
    }

    markAdminInCCtimesheetReminderMails = () => {
        this.setState({
            timesheetReminderCCAdmin: !this.state.timesheetReminderCCAdmin
        })
    }
    getBannerMessageForEmployeeList = () => {
        let messageGroup = [
          {
            message: `Please note that Auto clock-out settings apply to Attendance as well as Timesheet modules.<br>
            This configuration impacts OT calculation and will be reflected in pay run processing. Check info for more details.`,
            isAction: false,
          },
        ];
        return messageGroup;
    }

    getWorkWeekRow() {
        let filterWorkingDay = this.workweek.filter(day=> day.isWorkingDay)
        return filterWorkingDay.map((data, index) => {
            return (<>
                {data.isWorkingDay && <tr>
                    <td className="text-capitalize"> {data.day} </td>
                    <td>
                        <DKInputDateTime
                            title={`Select Time`}
                            hideCalendar={true}
                            className="w-70 m-v-s "
                            hideLabel={true}
                            readOnly={!this.state.hasEditAccess}
                            selectedDate={moment(data.startTime,"hh:mm A").format()}
                            onSave={(date) => {

                                data.startTime = moment(date).format("hh:mm A")
                                this.setTimeAndDuration(data);
                                }
                            }
                        />
                    </td>
                    <td>
                        <DKInputDateTime
                            title={`Select Time`}
                            hideCalendar={true}
                            className="w-70 m-v-s"
                            hideLabel={true}
                            readOnly={!this.state.hasEditAccess}
                            selectedDate={moment(data.endTime,"hh:mm A").format()}
                            onSave={(date) => {

                                data.endTime = moment(date).format("hh:mm A");
                                this.setTimeAndDuration(data);

                            }
                            }
                        />
                    </td>
                    <td> {data.duration} Hours </td>
                    <td>
                        {
                            index == 0 && (
                                <DKButton
                                    icon={DKIcons.ic_copy}
                                    disabled={!this.state.hasEditAccess}
                                    title={`${isViewportLarge() ? "Copy time to all":""} `}
                                    className="text-app"
                                    onClick={()=>{
                                        this.copyTimeToAll(data,filterWorkingDay)
                                    }}
                                />
                            )
                        }
                    </td>
                </tr>}</>
            )
        })
    }

    getCPFAccountsSection() {
        return (
          <div className="row">
            <div className="bg-white p-h-xl pt-r pb-l column align-items-center">
              <div>
                <DKIcon
                  src={addIcon}
                  className="ml-s ml-r mt-xs cursor-hand "
                  onClick={() => {
                    if(this.state.hasEditAccess) {
                        this.addNewACPFAccount();
                    }
                    
                  }}
                />
              </div>
              <div className="fw-m mt-s">Add New</div>
              <div className="mt-s">Add New CPF Account for your country</div>
            </div>
            <div className="row">
              {this.state?.cpfAccounts?.map((account, index) => {
                return (
                  <div
                    className="ml-m bg-white p-h-xl pt-r pb-l border-m border-radius-m border-box dashboard-card column cpf-account-wrapper"

                  >
                    <div>
                      <div className="fs-m fw-m">
                        {account.compliance?.name}
                      </div>
                      <div>{account.compliance?.submissionNumber}</div>
                    </div>
                    <div className="mt-m">
                      <div>
                        {this.getCPFAccountOrganizationIdName(
                          account.compliance.organizationId
                        )}
                      </div>
                      <div>{account.compliance?.organizationIdNumber}</div>
                    </div>
                    <div className="row justify-content-end actionButtons">
                      <DKIcon
                        src={DKIcons.ic_edit}
                        onClick={() => {
                            if(this.state.hasEditAccess) {
                                this.editCPFAccount(account);
                            }
                          
                        }}
                        className="ic-s cursor-hand"
                      />
                      <DKIcon
                        src={DKIcons.ic_delete}
                        onClick={() => {
                          this.deleteCPFAccount(account);
                        }}
                        className="ml-m ic-s cursor-hand"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
    }

    getWorkWeekSection() {
        return (
            <div className="parent-width">
                <DKLabel className="fw-m" text="Select working days" />
                <div className="row mt-l row-responsive">
                    {
                        this.workweek.map(day => {
                            return (
                                <DKButton
                                    className={` work-week-btn marging-bottom-mobile text-uppercase border-m mr-r ${day.isWorkingDay ? "selected text-app" : "bg-gray1"} `}
                                    title={day.day}
                                    disabled={!this.state.hasEditAccess}
                                    onClick={() => {
                                        day.isWorkingDay = !day.isWorkingDay;
                                        this.setState({
                                            ...this.state
                                        })
                                    }}
                                />
                            )
                        })
                    }
                </div>
                <div className="row mt-l">
                    <div className="web-width-70" style={{
                        overflowX: "auto"
                    }}>
                        <table className="parent-width">
                            <tr>
                                <th className="border_bottom_workweek text-align-left p-v-m" style={{minWidth:90}}>Day</th>
                                <th className="border_bottom_workweek text-align-left p-v-m" style={{minWidth:140}}>Start Time</th>
                                <th className="border_bottom_workweek text-align-left p-v-m" style={{minWidth:140}}>End Time</th>
                                <th className="border_bottom_workweek text-align-left p-v-m" style={{minWidth:90}}>Total Hours</th>
                                <th className="border_bottom_workweek text-align-left p-v-m"></th>
                            </tr>
                            {this.getWorkWeekRow()}
                        </table>
                    </div>
                </div>
            </div>
        )
    }

    getUSCheckPrintFields(){
        return(
            <div className="pl-l">
                <div>
                    <DKLine className="bg-line-2 mb-xxl" />

                    <div className="pb-l p-h-l position-relative">
                        <div className="row parent-width">
                            <Toggle
                                className="mr-s border-n"
                                isOn={this.state.isCheckPrint}
                                onChange={this.enableCheckPrint.bind(this)}
                            />
                            <span className="mb-xs">Enable Direct Payouts and Check Printing</span>
                            <div className="ml-m">
                                <ReactTooltip type="dark" place="right" html={true} effect='solid' />
                                <span data-tip="Please add the bank account to utilize the <br> Direct Deposit and Check printing features.">
                                    <DKIcon className="ic-s-2" src={ic_info_warning} />
                                </span>
                            </div>
                        </div>
                        
                        {this.state.isCheckPrint && <><div className="row mt-xl" style={{width:"48%"}}>
                             <DKInput
                                title="Check Number"
                                type={INPUT_TYPE.TEXT}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                required={true}
                                errorMessage="Please enter correct check number"
                                value={this.state.checkNumber.value}
                                canValidate={this.state.checkNumber.canValidate}
                                tooltip = {{
                                    "content" : "Please choose a higher number as a<br> starting point for your check number.",
                                    "className" : "warning-tooltip-prop"
                                }}
                                onChange={(value) => {
                                    this.state.checkNumber.canValidate = true
                                    let val = {
                                        value:value,
                                        canValidate:true
                                    }
                                    if(value.length <= this.state.checkNumber.validation.max && Utility.isValidNumber(value)&& (value != Utility.STRING_EMPTY)) {
                                        val.isValid = true;
                                    } else {
                                        val.isValid = false;
                                        if(value == Utility.STRING_EMPTY) {
                                            this.state.checkNumber.isValid = false
                                        }
                                    }
                                    this.state.checkNumber.value = value
                                    if(value != Utility.STRING_EMPTY){
                                        this.onChangeCheckNumber(val)
                                    }
                                    
                                }} 
                            />
                            {((!this.state.checkNumber.isValid)&& this.state.checkNumber.value ) && <DKLabel
                        className="text-red"
                        text="Check Number should have maximum 9 digits."/>}
                        </div>
                        </>}
                    </div>
                </div>
            </div>
        )
    }

    getCategorySection() {
        return (
          <>
            <div className="pl-l">
              <div>
                <DKLine className="bg-line-2 mb-xxl" />
                <div className="pb-l p-h-l position-relative">
                  <div className="row parent-width">
                    <Toggle
                      className="mr-s border-n"
                      isOn={this.state.isLocationActive}
                      onChange={() => this.enableDisableLocationSettings()}
                    />
                    <span className="mb-xs">Track locations</span>
                  </div>
                </div>
              </div>
            </div>
            {this.state.isLocationActive && (
              <div className="pl-l parent-width">
                <div className="row pt-m">
                  {this.state.locationType &&
                    this.getField(
                      "locationType",
                      this.state.locationType,
                      -1,
                      this.state.isDesktop ? "35%" : "100%"
                    )}
                </div>
              </div>
            )}
          </>
        );
    }
    getPayrunSettingsSection() {
        return (
            <>
                <div className="">
                    <DKLabel className="pt-l p-h-xxl" text="Payrun calculation by " />
                    <div className="row p-l p-h-xxl">
                        <div className="row" style={{ width: "auto" }}>
                            <DKRadioButton
                                isSelected={this.state.payrunCalcCriteria == PAYRUN_CALC_CRITERIAS.NO_OF_DAYS_WORKED}
                                color="bg-app"
                                onClick={() => {
                                    this.setState({
                                        payrunCalcCriteria: PAYRUN_CALC_CRITERIAS.NO_OF_DAYS_WORKED
                                    })
                                }}
                            />
                            <DKLabel className="ml-s mr-l" text="Days worked in a month" />
                        </div>
                        <div className="row" style={{ width: "auto" }}>
                            <DKRadioButton
                                isSelected={this.state.payrunCalcCriteria == PAYRUN_CALC_CRITERIAS.NO_OF_CALENDAR_DAYS}
                                color="bg-app"
                                onClick={() => {
                                    this.setState({
                                        payrunCalcCriteria: PAYRUN_CALC_CRITERIAS.NO_OF_CALENDAR_DAYS
                                    })
                                }}
                            />
                            <DKLabel className="ml-s mr-l" text="Calendar days in a month" />
                        </div>
                    </div>
                </div>
            </>
        )
    }

    getSectionHeader(section, isSaveVisible) {
        return (
            <div className="row p-h-xxl ">
                <DKLabel text={section} className="fw-m fs-l pt-l pb-s" />
                {isSaveVisible && (
                    <DKButton
                        title={"Save"}
                        disabled={!this.state.hasEditAccess}
                        className="border-m bg-app text-white ml-auto mr-s"
                        onClick={() => {
                            this.update(section);
                        }}
                    />
                )}
            </div>
        );
    }

    getHeaderForStep() {
        return (
            <div className="row justify-content-between p-h-xxl p-v-m bg-gray2">
                <DKLabel text={SECTION.COMPANY_DETAILS} className="fs-l fw-m" />
                <DKButton
                    title={"Close"}
                    className="border-m bg-white ml-auto"
                    onClick={() => {
                        this.props.onClose();
                    }}
                />
                <DKButton
                    title={"Save & Next"}
                    className="border-m bg-app text-white ml-m"
                    disabled={!this.state.hasEditAccess}
                    onClick={() => {
                        this.update(SECTION.ALL);
                    }}
                />
            </div>
        )
    }

    render() {
        const mainTenantData = TenantManager.getPeopleTenantData();
        return (
            <>
                <ReactTooltip type="dark" place="right" html={true} effect="solid" />
                <div className="parent-width">
                    <div className={`parent-width bg-white border-radius-s card-shadow ${this.props.renderAsStep ? "pb-m" : "p-v-m"}`}>
                        <ReactTooltip type="dark" place="right" html={true} effect="solid" />

                        {/* Company Details */}
                        {this.props.renderAsStep && this.getHeaderForStep()}
                        {this.getSectionHeader(SECTION.COMPANY_DETAILS, (!this.props.renderAsStep && isCompanyDetailsSectionWiseSave()))}
                        <DKLine className="bg-line-2" />
                        <div className="p-l">
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                {this.state.companyFields && this.renderCompanyFields()}
                                {this.state.complianceFields && this.renderComplianceFields()}
                                {this.state.extraFields && this.renderExtraFields()}
                            </div>
                            {isUSCompliance() &&
                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    {this.state.checkIntegrationFields && this.state.checkIntegrationFields.map((field, index) => this.getField("checkIntegrationFields", field, index, "50%"))}
                                </div>
                            }
                        </div>

                        {/* Contact Details */}
                        {this.getSectionHeader(SECTION.CONTACT_DETAILS, (!this.props.renderAsStep && isCompanyDetailsSectionWiseSave()))}
                        <DKLine className="bg-line-2" />
                        <div className="p-l">
                            {this.state.addressFields && (
                                <Address
                                    className="pb-l"
                                    countryCode={this.state.countryCode}
                                    addressFields={this.state.addressFields}
                                    module={ADDRESS_MODULE.COMPANY_DETAILS}
                                    isReadOnly={!this.state.hasEditAccess}
                                    onChange={(addressFields) => {
                                        this.updateState("addressFields", addressFields);
                                    }}
                                />
                            )}
                        </div>

                        {!this.props.renderAsStep && <Fragment>
                            {/* Check Printing */}
                            {isUSCompliance() && this.getSectionHeader(SECTION.CHECK_PRINTING, isCompanyDetailsSectionWiseSave())}
                            {isUSCompliance() && this.getUSEmailSpecificFields()}

                            {/* Date Format */}
                            {this.getSectionHeader(SECTION.DATE_FORMAT, isCompanyDetailsSectionWiseSave())}
                            <DKLine className="bg-line-2" />
                            <div className="row p-l">
                                {this.state.dateFormat && this.getField("dateFormat", this.state.dateFormat, -1, this.state.isDesktop ? "25%" : "100%")}
                                {this.state.dateFormat && this.state.dateFormat.value && (
                                    <div className="row mt-s">
                                        <DKLabel text="Sample Date: " />
                                        <DKLabel className="fw-m" text={this.getSampleDate()} />
                                    </div>
                                )}
                            </div>

                            {/* Decimal Places */}
                            {this.getSectionHeader(SECTION.DECIMAL_PLACES, isCompanyDetailsSectionWiseSave())}
                            <DKLine className="bg-line-2" />
                            <div className="row p-l">
                                {this.state.decimalFormat && this.getField("decimalFormat", this.state.decimalFormat, -1, this.state.isDesktop ? "25%" : "100%")}
                                {this.state.decimalFormat && this.state.decimalFormat.value && (
                                    <div className="row mt-s">
                                        <DKLabel text="Sample Amount: " />
                                        <DKLabel className="fw-m" text={this.getSampleAmount()} />
                                    </div>
                                )}
                            </div>

                            <div>
                                {this.getSectionHeader(SECTION.AUTO_CLOCk_OUT_SETTINGS, false)}
                                <DKLine className="bg-line-2" />
                                <div className="row p-h-l pt-l">
                                    <MessageInfo
                                        message={this.getBannerMessageForEmployeeList()}
                                        bannerClass="mb-l"
                                        isClosable={false}
                                    />
                                </div>
                                <div className="p-l">
                                    <div className="row pb-l p-h-l">
                                        <Toggle className="mr-s border-n" isOn={this.state.isAutoClockOutEnabled} onChange={() => {
                                            if(this.state.hasEditAccess) {
                                                this.enableDisableAutoClockOut()
                                            }
                                            }
                                        } />
                                        <span className="mb-xs">{`Click to ${this.state.isAutoClockOutEnabled ? "disable" : "enable"} Auto Clock-out`}</span>
                                    </div>
                                    {this.state.isAutoClockOutEnabled && this.state.autoClockOut && this.getField("autoClockOut", this.state.autoClockOut, -1, this.state.isDesktop ? "50%" : "50%")}

                                </div>
                            </div>
                            <div>
                                {this.getSectionHeader(SECTION.TIMESHEET_SETTINGS, false)}
                                <DKLine className="bg-line-2" />
                                <div className="p-l">
                                    <div className="row pb-l p-h-l">
                                        <Toggle className="mr-s border-n" isOn={this.state.timesheetPastDateRestrictionSet} onChange={() => {
                                            if(this.state.hasEditAccess) {
                                                this.enableDisableTimesheetPastDateRestriction()
                                            }
                                            }
                                        } 
                                        />
                                        <span className="mb-xs">{`Click to ${this.state.timesheetPastDateRestrictionSet ? "disable" : "enable"} past date timesheet restrictions`}</span>
                                    </div>
                                    {this.state.timesheetPastDateRestrictionSet && this.getField("timesheetRestrictionConfig", this.state.timesheetRestrictionConfig, -1, this.state.isDesktop ? "50%" : "50%")}
                                    <div className="row pb-l p-h-l">
                                        <Toggle className="mr-s border-n" isOn={this.state.timesheetReminderEnabled} onChange={() => {
                                            if(this.state.hasEditAccess) {
                                                this.enableDisableTimesheetReminderMail()
                                            }
                                            }} 
                                        />
                                        <span className="mb-xs">{`Click to ${this.state.timesheetReminderEnabled ? "disable" : "enable"} timesheet reminder Emails to employees`}</span>
                                    </div>
                                    {this.state.timesheetReminderEnabled && this.getField("timesheetReminderConfig", this.state.timesheetReminderConfig, -1, this.state.isDesktop ? "50%" : "50%")}
                                    {this.state.timesheetReminderEnabled &&
                                    <div className="row pb-l p-h-l">
                                        <DKCheckMark className="pt-s" isSelected={this.state.timesheetReminderCCAdmin} color="bg-app" onClick={() => {
                                            if(this.state.hasEditAccess) {

                                                this.markAdminInCCtimesheetReminderMails()
                                            }
                                            }}
                                            
                                        />
                                        <DKLabel className="pt-s pl-xs" text={`Keep Admin in CC in timesheet Reminder Emails to employees`} />
                                    </div>}
                                </div>
                            </div>
                            {/*  Change Language */}
                            {false && 
                                <Fragment>
                                    <DKLabel text="Change Language" className="fw-m fs-l p-h-xxl p-v-m" />
                                    <DKLine className="bg-line-2" />
                                    <div className="row p-l">
                                        {this.state.language &&
                                            this.getField(
                                                "language",
                                                this.state.language,
                                                -1,
                                                this.state.isDesktop ? "25%" : "100%"
                                            )}
                                    </div>
                                </Fragment>
                            }

                            {/* Work Week */}
                            {this.getSectionHeader(SECTION.WORK_WEEK, isCompanyDetailsSectionWiseSave())}
                            <DKLine className="bg-line-2" />
                            <div className="row p-l p-h-xxl">
                                {this.getWorkWeekSection()}
                            </div>

                            {/* Payrun Settings */}
                            <div className="">
                                {this.getSectionHeader(SECTION.PAYRUN_SETTINGS, isCompanyDetailsSectionWiseSave())}
                                <DKLine className="bg-line-2" />
                                <DKLabel className="pt-l p-h-xxl ml-s" text="Payrun calculation by " />
                                <div className="row p-h-xxl pt-m pb-l ml-s">
                                    <div className="row" style={{ width: "auto" }}>
                                        <DKRadioButton
                                            isSelected={ this.state.payrunCalcCriteria === PAYRUN_CALC_CRITERIAS.NO_OF_DAYS_WORKED}
                                            color="bg-app"
                                            onClick={() => {
                                                if(this.state.hasEditAccess) {
                                                    this.setState({
                                                        payrunCalcCriteria: PAYRUN_CALC_CRITERIAS.NO_OF_DAYS_WORKED
                                                    });
                                                }
                                            }}
                                        />
                                        <DKLabel className="ml-s mr-l" text="Days worked in a month" />
                                    </div>
                                    <div className="row" style={{ width: "auto" }}>
                                        <DKRadioButton
                                            isSelected={this.state.payrunCalcCriteria === PAYRUN_CALC_CRITERIAS.NO_OF_CALENDAR_DAYS}
                                            color="bg-app"
                                            onClick={() => {
                                                if(this.state.hasEditAccess) {
                                                    this.setState({
                                                        payrunCalcCriteria: PAYRUN_CALC_CRITERIAS.NO_OF_CALENDAR_DAYS
                                                    });
                                                }
                                            }}
                                        />
                                        <DKLabel className="ml-s mr-l" text="Calendar days in a month" />
                                    </div>
                                </div>
                            </div>

                            {/* ATTENDANCE ATTACHMENT*/}
                            <div className="">
                                {this.getSectionHeader(SECTION.ATTENDANCE_ATTACHMENT, false)}
                                <DKLine className="bg-line-2" />
                                <div className="row p-h-xxl pt-m pb-l ">
                                    <div className="row p-v-l">
                                        <Toggle className="mr-s border-n" isOn={this.state.isAttendanceAttachmentsEnabled} onChange={() => {
                                            if(this.state.hasEditAccess) {
                                                this.setState({
                                                    isAttendanceAttachmentsEnabled : !this.state.isAttendanceAttachmentsEnabled
                                                })
                                            }
                                        }} />
                                        <span className="mb-xs">{`Click to ${this.state.isAttendanceAttachmentsEnabled ? "disable" : "enable"} Attendance Attachment`}</span>
                                    </div>
                                </div>
                            </div>

                            {/* CPF Account */}
                            {getTenantCountryCode() === COUNTRY.SG && (
                                <div>
                                    {this.getSectionHeader(SECTION.CPF_ACCOUNT, false)}
                                    <DKLine className="bg-line-2" />
                                    <div className="row p-l p-h-xxl">
                                        {this.getCPFAccountsSection()}
                                    </div>
                                </div>
                            )}

                            {/* EPF Account */}
                            {getTenantCountryCode() === COUNTRY.MY && (
                                <div>
                                    {this.getSectionHeader(SECTION.EPF_ACCOUNT, false)}
                                    <DKLine className="bg-line-2" />
                                    <div className="row p-l p-h-xxl">
                                        {this.getEPFAccountsSection()}
                                    </div>
                                </div>
                            )}

                            {/* CUSTOM_FIELD_SECTION_ENABLED*/}
                            {(getTenantCountryCode() === COUNTRY.IL && !mainTenantData?.tenant?.customSectionFieldsEnabled) && <div className="">
                                {this.getSectionHeader(SECTION.CUSTOM_FIELD_SECTION_ENABLED, true)}
                                <DKLine className="bg-line-2" />
                                <div className="row p-h-xxl pt-m  ">
                                    <div className="row p-v-l">
                                        <Toggle 
                                            className={`mr-s border-n ${mainTenantData?.tenant?.customSectionFieldsEnabled ? "disable-button":""} `}
                                            isOn={this.state.customSectionFieldsEnabled} onChange={() => {
                                            if(this.state.hasEditAccess) {
                                                if(!mainTenantData?.tenant?.customSectionFieldsEnabled ) {
                                                    this.setState({
                                                        customSectionFieldsEnabled : !this.state.customSectionFieldsEnabled
                                                    })
                                                }
                                            }
                                        }} />
                                        <span className="mb-xs">{`Click to ${this.state.customSectionFieldsEnabled ? "disable" : "enable"} ${SECTION.CUSTOM_FIELD_SECTION_ENABLED}`}</span>
                                    </div>
                                    {this.state.customSectionFieldsEnabled && <div className="row p-v-l">
                                        <Toggle
                                            className={`mr-s border-n ${mainTenantData?.tenant?.customSectionFieldsEnabled && mainTenantData?.tenant?.isContractor ? "disable-button":""} ? "disable-button":""}`}
                                            isOn={this.state.isContractor} onChange={() => {
                                                if (this.state.hasEditAccess) {
                                                    this.setState({
                                                        isContractor: !this.state.isContractor
                                                    })
                                                }
                                            }} />
                                        <span className="mb-xs">{`Click to ${this.state.isContractor ? "disable" : "enable"} Contractor`}</span>
                                    </div>}
                                    
                                </div>
                                
                                {this.state.customSectionFieldsEnabled && <div className="row p-h-r pt-m pb-l ">
                                    {this.getField("pwRegionField", this.state.pwRegionField, -1, this.state.isDesktop ? "50%" : "50%")}
                                </div>}
                                
                            </div>}
                            {/* SAVE_PROGRESS_EMP_PROFILE*/}
                            { this.state.customSectionFieldsEnabled && <div className="">
                                {this.getSectionHeader(SECTION.SAVE_PROGRESS_EMP_PROFILE, true)}
                                <DKLine className="bg-line-2" />
                                <div className="row p-h-xxl pt-m  ">
                                    <div className="row p-v-l">
                                        <Toggle 
                                            className={`mr-s border-n  `}
                                            isOn={this.state.progressEmployeeProfileSaveButton} onChange={() => {
                                            if(this.state.hasEditAccess) {
                                                this.setState({
                                                    progressEmployeeProfileSaveButton : !this.state.progressEmployeeProfileSaveButton
                                                })
                                            }
                                        }} />
                                        <span className="mb-xs">{`Allow user to save progress of Employee Profile using Save button`}</span>
                                    </div>
                                    
                                    
                                </div>
                                
                                
                            </div>}
                        </Fragment>}
                    </div>

                    {!this.props.renderAsStep &&
                        <div className="d-flex p-v-l">
                            <DKButton
                                title="Update"
                                disabled={!this.state.hasEditAccess}
                                className="border-m bg-app text-white mr-r"
                                onClick={() => {
                                    this.update(SECTION.ALL);
                                }}
                            />
                            <DKButton
                                title="Cancel"
                                className="border-m bg-gray1"
                                onClick={() => {
                                    RouteManager.navigateToHome();
                                }}
                            />
                        </div>
                    }

                    {this.state.cpfAccountConfig?.isAddCpfenabled && (
                        <AddCpfAccount
                            isEdit={this.state.cpfAccountConfig?.isEdit}
                            onClose={(value) => this.onCPFPopUpClose(value)}
                            details={this.state.cpfAccountConfig?.accountDetails}
                        />
                    )}
                    {this.state.epfAccountConfig?.isAddEpfenabled && (
                        <AddEpfAccount
                            isEdit={this.state.epfAccountConfig?.isEdit}
                            onClose={(value) => this.onEPFopUpClose(value)}
                            details={this.state.epfAccountConfig?.epfAccountDetails}
                        />
                    )}
                </div>
            </>
        );
    }
}

const mapStateToProps = (state ) => ({
    cpfepfAccountDetails: state?.employee?.CPFAccounts || {}
})

const mapDispatchToProps = { fetchCPFAccount };

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetails);

